module.exports = __webpack_public_path__ + "90c9068dd0cea973c36b7daaf71d6d30.svg";